import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  SpecificElement1fm8kkyg4nw48 as SpecificElement,
  FuzzyIndex1f984se19g5yx as FuzzyIndex,
} from './RecyclerViewAnchor.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { roundToInt1ue8x8yshtznx as roundToInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import { Size2b01934yxlz5f as Size } from '../../models/Rect.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RecyclerViewPagingPlacerClass;
function RecyclerViewPagingPlacer() {
  if (RecyclerViewPagingPlacerClass === VOID) {
    class $ {
      constructor() {
        this.fdk_1 = null;
      }
      ndg(dataRange, anchor, previousViewport, existingCells, getNewCell, viewport, overdraw, paddingTop, paddingLeft, paddingRight, paddingBottom, gap) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = existingCells.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp0_safe_receiver = this.fdk_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.hcv(['    Index ' + element.nas() + ' at ' + element.tdg() + ' (viewport.left: ' + viewport.ld0_1 + ', previousViewport.left: ' + previousViewport.ld0_1 + ')']);
          }
        }
        var tmp;
        if (anchor == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp_0;
          if (anchor instanceof FuzzyIndex()) {
            tmp_0 = to(viewport.ld0_1 - anchor.adk_1 % 1 * viewport.pd0(), numberToInt(anchor.adk_1));
          } else {
            if (anchor instanceof SpecificElement()) {
              tmp_0 = to(viewport.ld0_1, anchor.ydj_1);
            } else {
              noWhenBranchMatchedException();
            }
          }
          tmp = tmp_0;
        }
        var tmp1_elvis_lhs = tmp;
        var tmp_1;
        if (tmp1_elvis_lhs == null) {
          var tmp$ret$4;
          $l$block_0: {
            // Inline function 'kotlin.collections.minByOrNull' call
            var iterator = existingCells.m1();
            if (!iterator.n1()) {
              tmp$ret$4 = null;
              break $l$block_0;
            }
            var minElem = iterator.o1();
            if (!iterator.n1()) {
              tmp$ret$4 = minElem;
              break $l$block_0;
            }
            var it = minElem;
            var tmp0_safe_receiver_0 = this.fdk_1;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              tmp0_safe_receiver_0.hcv(['' + it.nas() + ': abs((' + it.vdg() + ' + ' + it.tdg() + ') / 2 - ' + previousViewport.rd0() + ')']);
            }
            // Inline function 'kotlin.math.abs' call
            var x = (it.vdg() + it.tdg()) / 2 - previousViewport.rd0();
            var minValue = Math.abs(x);
            do {
              var e = iterator.o1();
              var tmp0_safe_receiver_1 = this.fdk_1;
              if (tmp0_safe_receiver_1 == null)
                null;
              else {
                tmp0_safe_receiver_1.hcv(['' + e.nas() + ': abs((' + e.vdg() + ' + ' + e.tdg() + ') / 2 - ' + previousViewport.rd0() + ')']);
              }
              // Inline function 'kotlin.math.abs' call
              var x_0 = (e.vdg() + e.tdg()) / 2 - previousViewport.rd0();
              var v = Math.abs(x_0);
              if (compareTo(minValue, v) > 0) {
                minElem = e;
                minValue = v;
              }
            }
             while (iterator.n1());
            tmp$ret$4 = minElem;
          }
          var tmp2_safe_receiver = tmp$ret$4;
          var tmp_2;
          if (tmp2_safe_receiver == null) {
            tmp_2 = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp_3;
            if (!(roundToInt(previousViewport.pd0()) === roundToInt(viewport.pd0()))) {
              var tmp0_safe_receiver_2 = this.fdk_1;
              if (tmp0_safe_receiver_2 == null)
                null;
              else {
                tmp0_safe_receiver_2.hcv(['Viewport size change!']);
              }
              tmp_3 = to(viewport.rd0() + ((tmp2_safe_receiver.vdg() + tmp2_safe_receiver.tdg()) / 2 - previousViewport.rd0()) - viewport.pd0() / 2, tmp2_safe_receiver.nas());
            } else {
              tmp_3 = to(tmp2_safe_receiver.tdg(), tmp2_safe_receiver.nas());
            }
            tmp_2 = tmp_3;
          }
          tmp_1 = tmp_2;
        } else {
          tmp_1 = tmp1_elvis_lhs;
        }
        var tmp3_elvis_lhs = tmp_1;
        var tmp_4;
        if (tmp3_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          tmp_4 = to(viewport.ld0_1, dataRange.i2_1);
        } else {
          tmp_4 = tmp3_elvis_lhs;
        }
        var _destruct__k2r9zo = tmp_4;
        var anchorXStart = _destruct__k2r9zo.cf();
        var anchorIndex = _destruct__k2r9zo.df();
        var tmp4_safe_receiver = this.fdk_1;
        if (tmp4_safe_receiver == null)
          null;
        else {
          tmp4_safe_receiver.hcv(['Anchor is ' + anchorXStart + ' index ' + anchorIndex]);
        }
        var size = new (Size())(viewport.pd0(), viewport.qd0());
        var containsLower = dataRange.i2_1;
        if (anchorIndex <= dataRange.j2_1 ? containsLower <= anchorIndex : false) {
          getNewCell(anchorIndex, size).xdg(anchorXStart, viewport.md0_1, anchorXStart + viewport.pd0(), viewport.od0_1);
        }
        var containsLower_0 = dataRange.i2_1;
        var containsUpper = dataRange.j2_1;
        var containsArg = anchorIndex + 1 | 0;
        if (containsLower_0 <= containsArg ? containsArg <= containsUpper : false) {
          getNewCell(anchorIndex + 1 | 0, size).xdg(anchorXStart + size.vd0_1, viewport.md0_1, anchorXStart + size.vd0_1 * 2, viewport.od0_1);
        }
        var containsLower_1 = dataRange.i2_1;
        var containsUpper_0 = dataRange.j2_1;
        var containsArg_0 = anchorIndex - 1 | 0;
        if (containsLower_1 <= containsArg_0 ? containsArg_0 <= containsUpper_0 : false) {
          getNewCell(anchorIndex - 1 | 0, size).xdg(anchorXStart - size.vd0_1, viewport.md0_1, anchorXStart, viewport.od0_1);
        }
      }
    }
    initMetadataForClass($, 'RecyclerViewPagingPlacer', RecyclerViewPagingPlacer);
    RecyclerViewPagingPlacerClass = $;
  }
  return RecyclerViewPagingPlacerClass;
}
//region block: exports
export {
  RecyclerViewPagingPlacer as RecyclerViewPagingPlacer1ttl0zmemv9d1,
};
//endregion

//# sourceMappingURL=RecyclerViewPagingPlacer.mjs.map
